// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-form-field {
  display: contents !important;
}

.box-label {
  position: relative;
  background-color: white;
  padding-right: 10px;
  padding-left: 10px;
  right: 30px;
}

@media (min-width: 992px) {
  .box-label {
    top: -15px;
  }
}
@media (max-width: 767px) {
  .box-label {
    top: 15px;
  }
}
.customs-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.label-address {
  display: inline-block;
  box-sizing: border-box;
  white-space: pre-line;
  word-wrap: break-word;
}

.label-customs-card {
  position: relative;
  background-color: white;
  top: -20px;
  padding-right: 10px;
  padding-left: 10px;
  right: 30px;
  font-size: medium !important;
}

.box {
  margin: 20px;
}

.customs-active-card {
  direction: rtl;
  box-shadow: 0 0 2.7907px rgba(0, 0, 0, 0), 0 2.7907px 2.7907px rgba(0, 0, 0, 0), 0px 1.39535px 4.18606px rgba(0, 0, 0, 0.16);
  margin-right: 20px;
  margin-left: 20px;
  padding-right: 20px;
  margin-top: 20px;
  padding-left: 20px;
}

.title-page {
  direction: rtl;
  font-size: medium;
  margin: 40px 20px 50px;
}

.select {
  font-size: small;
}

.submit {
  float: left;
  margin-bottom: 10px;
  margin-left: 20px;
  margin-top: 10px;
  --background: #628d9d !important;
}

.customs-card {
  direction: rtl;
  border-radius: 5px;
  padding: 10px;
  box-shadow: 0 0 2.7907px rgba(0, 0, 0, 0), 0 2.7907px 2.7907px rgba(0, 0, 0, 0), 0px 1.39535px 4.18606px rgba(0, 0, 0, 0.16);
}

.row {
  display: flex;
  justify-content: space-between;
}

.title {
  font-size: small !important;
}

.value {
  font-size: small !important;
}

.value-adress {
  font-size: small !important;
  text-align: start !important;
  margin-left: auto !important;
  margin-right: 10px;
}

.row {
  box-shadow: 0 0 2.7907px rgba(0, 0, 0, 0), 0 2.7907px 2.7907px rgba(0, 0, 0, 0), 0px 1.39535px 4.18606px rgba(0, 0, 0, 0.16);
  font-style: normal;
  font-weight: 400;
  font-size: small;
  line-height: 20px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
}

.button-port {
  background-color: white !important;
}

.buttons-group {
  display: flex;
  justify-content: end;
  margin-left: 10px;
}

.vl {
  border-left: 4px solid #084e5f;
  height: 100px;
  left: 50%;
  margin-left: -3px;
}

.box-transport-type {
  padding: 10px;
  background-color: 300px;
  color: white;
  border-radius: 10px;
  position: absolute;
  left: -28px;
  top: 33%;
}

.box-gr {
  position: relative;
  width: -webkit-fill-available;
  margin-left: 60px;
  margin-top: 5px;
  margin-bottom: 5px;
}

ion-note {
  font-size: 10px;
  margin-top: -15px;
}

mat-option {
  font-size: small !important;
}

.mandatory {
  font-size: x-small;
  color: red;
}

.optional {
  color: gray;
  font-size: smaller;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/customs/customs.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/shared/components/customs/customs.component.scss"],"names":[],"mappings":"AACA;EACE,4BAAA;ACAF;;ADEA;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;ACCF;;ADEA;EACE;IACE,UAAA;ECCF;AACF;ADCA;EACE;IACE,SAAA;ECCF;AACF;ADCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;ACCF;;ADCA;EACE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;ACEF;;ADAA;EACE,kBAAA;EACA,uBAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,4BAAA;ACGF;;ADDA;EACE,YAAA;ACIF;;ADFA;EACE,cAAA;EACA,4HAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;ACKF;;ADHA;EACE,cAAA;EACA,iBAAA;EACA,sBAAA;ACMF;;ADJA;EACE,gBAAA;ACOF;;ADLA;EACE,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gCAAA;ACQF;;ADNA;EACE,cAAA;EACA,kBAAA;EACA,aAAA;EACA,4HAAA;ACSF;;ADPA;EACE,aAAA;EACA,8BAAA;ACUF;;ADRA;EACE,2BAAA;ACWF;;ADTA;EACE,2BAAA;ACYF;;ADVA;EACE,2BAAA;EACA,4BAAA;EACA,4BAAA;EACA,kBAAA;ACaF;;ADXA;EACE,4HAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;ACcF;;ADZA;EACE,kCAAA;ACeF;;ADbA;EACE,aAAA;EACA,oBAAA;EACA,iBAAA;ACgBF;;ADdA;EACE,8BAAA;EACA,aAAA;EACA,SAAA;EACA,iBAAA;ACiBF;;ADfA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;ACkBF;;ADhBA;EACE,kBAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;ACmBF;;ADjBA;EACE,eAAA;EACA,iBAAA;ACoBF;;ADlBA;EACE,2BAAA;ACqBF;;ADnBA;EACE,kBAAA;EACA,UAAA;ACsBF;;ADpBA;EACE,WAAA;EACA,kBAAA;ACuBF","sourcesContent":["\r\nmat-form-field{\r\n  display: contents !important;\r\n}\r\n.box-label{\r\n  position: relative;\r\n  background-color: white;\r\n  padding-right: 10px;\r\n  padding-left: 10px;\r\n  right: 30px;\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .box-label {\r\n    top: -15px;\r\n  }\r\n}\r\n@media (max-width: 767px) {\r\n  .box-label {\r\n    top: 15px;\r\n  }\r\n}\r\n.customs-option{\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n.label-address{\r\n  display: inline-block;\r\n  box-sizing: border-box;\r\n  white-space: pre-line;\r\n  word-wrap: break-word;\r\n}\r\n.label-customs-card{\r\n  position: relative;\r\n  background-color: white;\r\n  top: -20px;\r\n  padding-right: 10px;\r\n  padding-left: 10px;\r\n  right: 30px;\r\n  font-size: medium !important;\r\n}\r\n.box{\r\n  margin: 20px;\r\n}\r\n.customs-active-card{\r\n  direction: rtl;\r\n  box-shadow: 0 0 2.7907px rgb(0 0 0 / 0%), 0 2.7907px 2.7907px rgb(0 0 0 / 0%), 0px 1.39535px 4.18606px rgb(0 0 0 / 16%);\r\n  margin-right: 20px;\r\n  margin-left: 20px;\r\n  padding-right: 20px;\r\n  margin-top: 20px;\r\n  padding-left: 20px;\r\n}\r\n.title-page{\r\n  direction: rtl;\r\n  font-size: medium;\r\n  margin: 40px 20px 50px;\r\n}\r\n.select{\r\n  font-size: small;\r\n }\r\n.submit{\r\n  float: left;\r\n  margin-bottom: 10px;\r\n  margin-left: 20px;\r\n  margin-top: 10px;\r\n  --background: #628d9d !important;\r\n}\r\n.customs-card{\r\n  direction: rtl;\r\n  border-radius: 5px;\r\n  padding: 10px;\r\n  box-shadow: 0 0 2.7907px rgb(0 0 0 / 0%), 0 2.7907px 2.7907px rgb(0 0 0 / 0%), 0px 1.39535px 4.18606px rgb(0 0 0 / 16%);\r\n}\r\n.row{\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n.title {\r\n  font-size: small !important;\r\n}\r\n.value{\r\n  font-size: small !important;\r\n}\r\n.value-adress{\r\n  font-size: small !important;\r\n  text-align: start !important;\r\n  margin-left: auto !important;\r\n  margin-right: 10px;\r\n}\r\n.row{\r\n  box-shadow: 0 0 2.7907px rgb(0 0 0 / 0%), 0 2.7907px 2.7907px rgb(0 0 0 / 0%), 0px 1.39535px 4.18606px rgb(0 0 0 / 16%);\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-size: small;\r\n  line-height: 20px;\r\n  margin-left: 10px;\r\n  margin-right: 10px;\r\n  padding: 10px;\r\n  margin-bottom: 10px;\r\n  border-radius: 5px;\r\n}\r\n.button-port{\r\n  background-color: white !important;\r\n}\r\n.buttons-group{\r\n  display: flex;\r\n  justify-content: end;\r\n  margin-left: 10px;\r\n}\r\n.vl {\r\n  border-left: 4px solid #084e5f;\r\n  height: 100px;\r\n  left: 50%;\r\n  margin-left: -3px;\r\n}\r\n.box-transport-type{\r\n  padding: 10px;\r\n  background-color: 300px;\r\n  color: white;\r\n  border-radius: 10px;\r\n  position: absolute;\r\n  left: -28px;\r\n  top: 33%;\r\n}\r\n.box-gr{\r\n  position: relative;\r\n  width: -webkit-fill-available;\r\n  margin-left: 60px;\r\n  margin-top: 5px;\r\n  margin-bottom: 5px;\r\n}\r\nion-note{\r\n  font-size: 10px;\r\n  margin-top: -15px;\r\n}\r\nmat-option {\r\n  font-size: small !important;\r\n}\r\n.mandatory{\r\n  font-size: x-small;\r\n  color: red;\r\n}\r\n.optional{\r\n  color: gray;\r\n  font-size: smaller;\r\n}","mat-form-field {\n  display: contents !important;\n}\n\n.box-label {\n  position: relative;\n  background-color: white;\n  padding-right: 10px;\n  padding-left: 10px;\n  right: 30px;\n}\n\n@media (min-width: 992px) {\n  .box-label {\n    top: -15px;\n  }\n}\n@media (max-width: 767px) {\n  .box-label {\n    top: 15px;\n  }\n}\n.customs-option {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.label-address {\n  display: inline-block;\n  box-sizing: border-box;\n  white-space: pre-line;\n  word-wrap: break-word;\n}\n\n.label-customs-card {\n  position: relative;\n  background-color: white;\n  top: -20px;\n  padding-right: 10px;\n  padding-left: 10px;\n  right: 30px;\n  font-size: medium !important;\n}\n\n.box {\n  margin: 20px;\n}\n\n.customs-active-card {\n  direction: rtl;\n  box-shadow: 0 0 2.7907px rgba(0, 0, 0, 0), 0 2.7907px 2.7907px rgba(0, 0, 0, 0), 0px 1.39535px 4.18606px rgba(0, 0, 0, 0.16);\n  margin-right: 20px;\n  margin-left: 20px;\n  padding-right: 20px;\n  margin-top: 20px;\n  padding-left: 20px;\n}\n\n.title-page {\n  direction: rtl;\n  font-size: medium;\n  margin: 40px 20px 50px;\n}\n\n.select {\n  font-size: small;\n}\n\n.submit {\n  float: left;\n  margin-bottom: 10px;\n  margin-left: 20px;\n  margin-top: 10px;\n  --background: #628d9d !important;\n}\n\n.customs-card {\n  direction: rtl;\n  border-radius: 5px;\n  padding: 10px;\n  box-shadow: 0 0 2.7907px rgba(0, 0, 0, 0), 0 2.7907px 2.7907px rgba(0, 0, 0, 0), 0px 1.39535px 4.18606px rgba(0, 0, 0, 0.16);\n}\n\n.row {\n  display: flex;\n  justify-content: space-between;\n}\n\n.title {\n  font-size: small !important;\n}\n\n.value {\n  font-size: small !important;\n}\n\n.value-adress {\n  font-size: small !important;\n  text-align: start !important;\n  margin-left: auto !important;\n  margin-right: 10px;\n}\n\n.row {\n  box-shadow: 0 0 2.7907px rgba(0, 0, 0, 0), 0 2.7907px 2.7907px rgba(0, 0, 0, 0), 0px 1.39535px 4.18606px rgba(0, 0, 0, 0.16);\n  font-style: normal;\n  font-weight: 400;\n  font-size: small;\n  line-height: 20px;\n  margin-left: 10px;\n  margin-right: 10px;\n  padding: 10px;\n  margin-bottom: 10px;\n  border-radius: 5px;\n}\n\n.button-port {\n  background-color: white !important;\n}\n\n.buttons-group {\n  display: flex;\n  justify-content: end;\n  margin-left: 10px;\n}\n\n.vl {\n  border-left: 4px solid #084e5f;\n  height: 100px;\n  left: 50%;\n  margin-left: -3px;\n}\n\n.box-transport-type {\n  padding: 10px;\n  background-color: 300px;\n  color: white;\n  border-radius: 10px;\n  position: absolute;\n  left: -28px;\n  top: 33%;\n}\n\n.box-gr {\n  position: relative;\n  width: -webkit-fill-available;\n  margin-left: 60px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\nion-note {\n  font-size: 10px;\n  margin-top: -15px;\n}\n\nmat-option {\n  font-size: small !important;\n}\n\n.mandatory {\n  font-size: x-small;\n  color: red;\n}\n\n.optional {\n  color: gray;\n  font-size: smaller;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
